import React, { FC } from 'react';
import { Theme } from './useLoaderConfig';
import styled, { css, keyframes } from 'styled-components';
import { LoaderProgress } from './LoaderProgress';
import { VendorLogo, VendorLogoSvg } from './VendorLogo';
import { VendorDarkLogo, VendorDarkLogoSvg } from './VendorDarkLogo';
import vendorLogo from '@assets/crash/logo-vendor.svg';

const BrandLoaderRoot = styled.div<{
    $color: string;
    $backgroundImage?: string;
}>(
    ({ $color, $backgroundImage }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 120;
        width: 100%;
        height: 100%;

        background: ${$backgroundImage ? `url(${$backgroundImage}) center / cover no-repeat` : $color};

        ${VendorLogoSvg},
        ${VendorDarkLogoSvg} {
            margin-top: auto;
            height: 4.62vh;
            margin-bottom: 5.92vh;

            @media (max-width: 512px) {
                height: 8.33vw;
                margin-bottom: 10vh;
            }
        }
    `,
);

const flash = keyframes`
    0%, 100% {
        filter: drop-shadow(0 0 40px rgba(255, 255, 255, 0.4));
    }
    50% {
        filter: drop-shadow(0 0 70px rgba(255, 255, 255, 0.4));
    }
`;

const BrandLoaderLogo = styled.img<{ $isDefault?: boolean }>`
    background: no-repeat center bottom / contain;
    margin-top: auto;
    max-width: 58vh;
    max-height: 58vh;

    ${({ $isDefault }) =>
        $isDefault &&
        css`
            animation: ${flash} 1.5s linear infinite;
        `}

    @media (max-width: 512px) {
        max-width: 64vw;
        max-height: 64vw;
    }
`;

interface BrandLoaderProps {
    config: Theme;
}

export const BrandLoader: FC<BrandLoaderProps> = ({ config }) => {
    return (
        <BrandLoaderRoot $color={config.backgroundColor!} $backgroundImage={config.backgroundImageUrl}>
            <BrandLoaderLogo
                $isDefault={!config.logoUrl}
                width={!config.logoUrl ? '100%' : '64%'}
                src={config.logoUrl || vendorLogo}
                alt="Casino Logo"
            />
            <LoaderProgress isDark={config.isDark} />
            {config.disableBottomLogo ? (
                <div style={{ marginTop: 'auto' }} />
            ) : config.isDark ? (
                <VendorDarkLogo />
            ) : (
                <VendorLogo />
            )}
        </BrandLoaderRoot>
    );
};
